export default __webpack_public_path__ + "static/media/skyMax.0a312f37.jpg";